export default {

	init() {
		const callback = (entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					document.body.classList.remove('bg-orange', 'bg-orange-100', 'bg-orange-200');
					document.body.classList.add(entry.target.dataset.color);
				}
			});
		};

		const changes = document.querySelectorAll('.bg-transition');

		const observer = new IntersectionObserver(callback, { threshold: 0.5 });

		changes.forEach((change) => {
			observer.observe(change);
		});
	},

};
